import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactLastContactedTime as GetContactLastContactedTimeQuery,
    GetContactLastContactedTimeVariables,
    ContactLastContactedTimeFragment,
} from 'nutshell-graphql-types';

import GET_CONTACT_LAST_CONTACTED_TIME from '../queries/get-contact-last-contacted-time.graphql';

export function useGetContactLastContactedTime(contactId: string): {
    contactLastContact: ContactLastContactedTimeFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetContactLastContactedTimeQuery,
        GetContactLastContactedTimeVariables
    >(GET_CONTACT_LAST_CONTACTED_TIME, {
        variables: {id: contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    return {
        contactLastContact: data?.contact ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
